import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "../components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(
        `${API}/auth/login`,
        { email, password },
        { withCredentials: true }
      );
      localStorage.setItem("ato_token", data.access_token);
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ocean px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <Link to="/" aria-label="Back to website">
            <span className="flex items-center gap-2.5 rounded-2xl bg-white px-5 py-3">
              <Logo />
            </span>
          </Link>
        </div>
        <form
          onSubmit={handleSubmit}
          data-testid="admin-login-form"
          className="rounded-3xl bg-white p-8 shadow-2xl"
        >
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-turquoise/10 text-turquoise">
              <Lock className="h-5 w-5" />
            </span>
            <div>
              <h1 className="font-display text-xl font-bold text-ink">Admin Login</h1>
              <p className="text-xs text-mutedink">View and manage travel enquiries</p>
            </div>
          </div>

          <div className="mt-6 space-y-4">
            <div>
              <label htmlFor="admin-email" className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-ocean/70">
                Email
              </label>
              <input
                id="admin-email" type="email" required value={email}
                data-testid="admin-email-input"
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-xl border border-ocean/15 px-4 py-3 text-base outline-none focus:border-turquoise focus:ring-2 focus:ring-turquoise/30"
                placeholder="admin@aroratravelonline.com"
              />
            </div>
            <div>
              <label htmlFor="admin-password" className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-ocean/70">
                Password
              </label>
              <input
                id="admin-password" type="password" required value={password}
                data-testid="admin-password-input"
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-xl border border-ocean/15 px-4 py-3 text-base outline-none focus:border-turquoise focus:ring-2 focus:ring-turquoise/30"
                placeholder="••••••••"
              />
            </div>
          </div>

          {error && (
            <p data-testid="admin-login-error" className="mt-4 rounded-xl bg-coral/10 px-4 py-3 text-sm font-medium text-coral">
              {error}
            </p>
          )}

          <button
            type="submit" disabled={loading}
            data-testid="admin-login-submit-button"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-ocean py-3.5 text-sm font-semibold text-white transition-colors hover:bg-turquoise disabled:opacity-60"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
